// AuthGuard.tsx
import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import LoadingScreen from "../core/components/LoadingScreen";
import Login from "../pages/authentication/Login";

interface Props {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, isInitialized } = useAuth();
  const location = useLocation();
  const returnPath = `${location.pathname}${location.search}`;
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null,
  );

  if (!isInitialized) return <LoadingScreen />;

  if (!isAuthenticated) {
    if (returnPath !== requestedLocation) {
      setRequestedLocation(returnPath);
    }
    return <Login />;
  }

  if (requestedLocation && returnPath !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} replace />;
  }

  return <>{children}</>;
};
